var React = require('react');

function IconSLATargetValue (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M155.61 418.73a28.36 28.36 0 0 1-27.12 20.06H28.35a28.36 28.36 0 0 1 0-56.71h79.15l47.57-155.86c8.48-27.78 48.29-26.35 54.76 2l56.05 245.36 113.08-452.1c7.58-30.34 51.48-27.86 55.61 3.13l76.38 572.81 104.46-370.63c7.76-27.49 46.7-27.57 54.55-.11l44.47 155.38h70a28.36 28.36 0 0 1 0 56.71h-91.38a28.37 28.37 0 0 1-27.27-20.55l-22.88-80-114.68 406.7c-8.36 29.64-51.33 26.57-55.4-4l-74.86-561.7-105.81 423.11c-7.19 28.94-48.51 28.51-55.19-.54l-58.71-257.21z"}));
}

IconSLATargetValue.displayName = "IconSLATargetValue";

IconSLATargetValue.defaultProps = {"data-name":"图层 1","viewBox":"0 0 812.83 765.58"};

module.exports = IconSLATargetValue;

IconSLATargetValue.default = IconSLATargetValue;
